const styles = {
  dashboardNavContainer: {
    position: 'fixed' as const,
    top: 0,
    left: 0,
    width: '200px',
    height: '100vh',
    background: '#F5F6F7',
    zIndex: 3000,
    transition: 'left 0.3s ease-in-out',
    '@media (max-width: 668px)': {
      left: '-200px',
    },
  },
  bottomNavWrapper: {
    top: 'initial',
    bottom: 0,
    height: 'auto',
    width: '100vw',
    textAlign: 'center' as const,
    zIndex: 100,
    display: 'flex',
    flexWrap: 'nowrap' as const,
  },
  bottomNav: {
    display: 'flex',
    a: {
      position: 'relative' as const,
      top: 0,
      left: 0,
      padding: 0,
      svg: {
        position: 'relative' as const,
        transform: 'translate(0, 0)',
        top: 0,
        left: 0,
      },
    },
  },
  hamburguerMenu: {
    position: 'absolute' as const,
    top: '26px',
    left: '24px',
    width: '24px',
    aspectRatio: '1',
    display: 'flex',
    justifyContent: 'space-evenly',
    flexDirection: 'column' as const,
    cursor: 'pointer',
    zIndex: 1001,
    div: {
      width: '100%',
      height: '12%',
      backgroundColor: '#616161',
      borderRadius: '100px',
    },
  },
  rootNavWrapper: {
    zIndex: 200,
    '@media (min-width: 669px)': {
      display: 'none',
    },
  },
  dashboardWrapper: {
    position: 'fixed' as const,
    top: 0,
    right: 0,
    width: 'calc(100% - 65px)',
    height: '100vh',
    transition: 'left 0.3s ease-in-out',
    backgroundColor: '#fff',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column' as const,
    '@media (max-width: 668px)': {
      position: 'fixed' as const,
      top: 0,
      bottom: '65px',
      left: 0,
      right: 0,
      width: 'auto',
      height: 'auto',
      overflow: 'hidden',
    },
    '@media (max-width: 756px)': {
      width: '100%',
    },
  },
  dashboardContainer: {
    position: 'relative' as const,
    width: '100%',
    flex: 1,
    minHeight: 0,
    background: '#F5F6F7',
    overflow: 'hidden' as const,
    display: 'flex',
    flexDirection: 'column' as const,
    '@media (max-width: 760px)': {
      width: '100%',
    },
  },
}

export default styles
